import ServiceBase from '../../ServiceBase';
import indexProxy from '../../../proxies/market/market-in-depth/IndexProxy';

class IndexService extends ServiceBase {
  getLatestIndices(params) {
    return this.processSubscription(data => {
      var res = [];

      for (var index of data.items) {
        res.push(this.getSubscribtionChannel(index.comGroupCode));
      }

      return res;
    })(() =>
      this.applyMemoryCache('MarketService.getComGroupList', params)(() =>
        indexProxy.getLatestIndices(params),
      ),
    );
  }

  getIndexSeries(params, source) {
    return this.applyMemoryCache(
      'ExchangeRealtimeService.getTodayIndexSeries',
      params,
    )(() => indexProxy.getIndexSeries(params, source));
  }
}

const indexService = new IndexService();
export default indexService;
